import { render, staticRenderFns } from "./ProfilePic.vue?vue&type=template&id=ad24900e&"
import script from "./ProfilePic.vue?vue&type=script&lang=js&"
export * from "./ProfilePic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VAvatar,VImg,VProgressCircular,VRow})
